import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';

interface GlobalVisualsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const GlobalVisualsSection: React.FC<GlobalVisualsSectionProps> = ({ config, setConfig }) => (
  <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-neutral-500/5 border-neutral-500/10 mb-4">
    <SmartInput label="Hue Speed" min={0} max={20} step={0.1} value={config.hueCycleSpeed} onChange={v => setConfig(p => ({...p, hueCycleSpeed: v}))} darkMode={config.darkMode} settingKey="hueCycleSpeed" />
    <SmartInput label="Shake Multiplier" min={0} max={5} step={0.1} value={config.shakeIntensityMultiplier} onChange={v => setConfig(p => ({...p, shakeIntensityMultiplier: v}))} darkMode={config.darkMode} settingKey="shakeIntensityMultiplier" />
    <SmartInput label="Shake Decay" min={0.5} max={0.99} step={0.01} value={config.shakeDecayRate} onChange={v => setConfig(p => ({...p, shakeDecayRate: v}))} darkMode={config.darkMode} settingKey="shakeDecayRate" />
    <SmartInput label="Counter Pop Decay" min={0.01} max={0.5} step={0.01} value={config.popDecayRate} onChange={v => setConfig(p => ({...p, popDecayRate: v}))} darkMode={config.darkMode} settingKey="popDecayRate" />
  </div>
);
